module.exports = __webpack_public_path__ + "img/YellowArrows_down.88a8e618.svg";